import { Vendor } from '../vendor/vendor';
import { Admin } from '../admin/admin';
import { DateTime } from 'luxon';
import { ProductType } from '../product/product';
import { OrderType } from '../order/order';
import { PaginationRequest } from '../pagination/pagination';

export enum PurchaseOrderStatus {
  Requested = 'Requested',
  Approved = 'Approved',
  Received = 'Received',
}

export type PurchaseOrder = {
  id: string;
  locationId: number;
  vendor: Vendor;
  poNumber?: string;
  purchasedBy: Admin;
  purchasedAt: DateTime;
  products: PurchaseOrderProductLineItem[];
  lineItems: PurchaseOrderLineItem[];
  paymentMethod?: PurchaseOrderPaymentMethod;
  subtotal: number;
  status: PurchaseOrderStatus;
  createdAt: DateTime;
  updatedAt: DateTime;
};

export type CreatePurchaseOrderRequest = {
  locationId: number;
  vendorId: number;
  poNumber?: string;
  purchasedById: number;
  purchasedAt: DateTime;
  paymentMethodId?: string;
  products: UpsertPurchaseOrderProductRequest[];
  lineItems: PurchaseOrderLineItemRequest[];
};

export type UpdatePurchaseOrderRequest = {
  poNumber?: string;
  paymentMethodId?: string;
  purchasedBy?: number;
  purchasedAt?: DateTime;
  products?: UpsertPurchaseOrderProductRequest[];
  lineItems?: PurchaseOrderLineItemRequest[]; // should this be upsert?
};

export type PurchaseOrderLineItem = {
  id: string;
  purchaseOrderId: string;
  name: string;
  unitPrice: number;
};

export type PurchaseOrderLineItemRequest = {
  id: string;
  name: string;
  unitPrice: number;
};

export type UpsertPurchaseOrderProductRequest = {
  id: string;
  type: ProductType;
  productType: OrderType;
  name: string;
  description?: string;
  quantity: number;
  unitPrice: number;
};

export type PurchaseOrderProductLineItem = PurchaseOrderProduct | PurchaseOrderPart | PurchaseOrderCustomProduct;

export type PurchaseOrderProduct = {
  id: string;
  purchaseOrderId: string;
  type: ProductType.Product;
  productType: OrderType;
  name: string;
  quantity: number;
  unitPrice: number;
};

export type PurchaseOrderPart = {
  id: string;
  purchaseOrderId: string;
  type: ProductType.Part;
  name: string;
  quantity: number;
  partNumber: string;
  unitPrice: number;
};

export type PurchaseOrderCustomProduct = {
  id: string;
  purchaseOrderId: string;
  type: ProductType.Custom;
  productType: OrderType;
  name: string;
  description?: string;
  quantity: number;
  unitPrice: number;
};

export type PurchaseOrderPaymentMethod = {
  id: string;
  name: string;
  description?: string;
  isActive: boolean;
};

export class PurchaseOrderSearchRequest extends PaginationRequest {
  keyword?: string;
  locationId?: number;
  vendorId?: number;
  purchasedById?: number;
}
